import { Box, Grid } from "@mui/material";
import React, { useState } from "react";
import CheminDeFer from "../../../components/cheminDeFer/CheminDeFer";
import Chip from "../../../components/Chip";
import FormButtons from "../../../components/FormButtons";
import Layout from "../../../components/Layout";

import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import Types from "Types";
import { Selectors as DossierLocationSelector } from "../../../redux/DossierLocation";
import { Selectors as SituationPersonnelleSelector } from "../../../redux/SituationPersonnelle";
import Libelle from "../../../_i18n/fr.json";
import { getTitleCandidat } from "../../../helpers/utils";
import { Selectors as DossierLocationSelectors } from "../../../redux/DossierLocation";
import { Selectors } from "../../../redux/Pieces";
import { Selectors as SituationPersoSelectors } from "../../../redux/SituationPersonnelle";
import {
  DossierLocation,
  DossierParticulierDetailTypeCompteEnum,
} from "../../../services/Api/swagger";
import IframePieces from "./IframePieces";
import styles from "./styles";

interface Props {
  token: string;
  tokenConjoint?: string;
  dossierLocation: DossierLocation;
  typeCompte?: DossierParticulierDetailTypeCompteEnum;
  refDossierLocataire?: string;
  selectedDossier?: string;
  selectedPerson?: string;
  nomPrenomLocataire?: string;
}

interface State {
  selected: string;
}

function PiecesJustificativesPage() {
  const modifIframeNetheos = useSelector((state: Types.RootState) =>
    DossierLocationSelectors.getTokenNetheos(state)
  );
  const modifIframeNetheosConjoint = useSelector((state: Types.RootState) =>
    DossierLocationSelectors.getTokenConjointNetheos(state)
  );

  const tokenFromPieces = useSelector((state: Types.RootState) =>
    Selectors.getTokenNetheos(state)
  );

  const tokenConjointFromPieces = useSelector((state: Types.RootState) =>
    Selectors.getTokenConjointNetheos(state)
  );
  const token = tokenFromPieces ? tokenFromPieces : modifIframeNetheos;

  const tokenConjoint = tokenConjointFromPieces
    ? tokenConjointFromPieces
    : modifIframeNetheosConjoint;

  const typeCompte = useSelector((state: Types.RootState) =>
    SituationPersoSelectors.getTypeCompte(state)
  );
  const refDossierLocataire = useSelector((state: Types.RootState) =>
    SituationPersoSelectors.getRefLocataireGarant(state)
  );
  const dossierLocation = useSelector((state: Types.RootState) =>
    DossierLocationSelectors.getDossierLocation(state)
  );
  // si selectedDossier existe (et non la référence de l'object data, ça signifie qu'on est en modification d'un dossier)
  const selectedDossier = useSelector((state: Types.RootState) =>
    DossierLocationSelectors.getSelectedDossier(state)
  );
  const selectedPerson = useSelector((state: Types.RootState) =>
    DossierLocationSelectors.getSelectedPerson(state)
  );
  const nomPrenomLocataire = useSelector((state: Types.RootState) =>
    SituationPersoSelectors.getNomLocataire(state)
  );

  const compositionLocation = useSelector((state: Types.RootState) =>
    DossierLocationSelector.getCompositionLocation(state)
  );

  const compositionLocationFormEnCours = useSelector((state: Types.RootState) =>
    SituationPersonnelleSelector.getCompositionLocation(state)
  );
  const [selected, setSelected] = useState("candidat");

  const navigate = useNavigate();
  const handlePrecedent = () => {
    navigate("/dossier-location/situation-professionnelle");
  };

  const handleSuivant = () => {
    navigate("/dossier-location/synthese");
  };

  const handleSelectCandidat = (ref: string) => {
    setSelected(ref);
  };

  const titlePage =
    dossierLocation &&
    typeCompte &&
    getTitleCandidat(
      dossierLocation,
      typeCompte,
      dossierLocation.dossiersParticuliers,
      refDossierLocataire || undefined,
      selectedPerson || undefined,
      nomPrenomLocataire || undefined,
      compositionLocationFormEnCours || compositionLocation
    );

  return (
    <React.Fragment>
      <Layout title={Libelle.pageJustificatifs.titre}>
        <CheminDeFer isEtape="justificatifs" />
        <Box sx={styles}>
          <>
            <h5 className="titlePage">{titlePage}</h5>
            {tokenConjoint ? (
              <>
                <Grid container wrap="nowrap" alignItems="flex-start">
                  <Chip
                    active={selected === "candidat"}
                    key={"candidat"}
                    onClick={() => handleSelectCandidat("candidat")}
                    label={"Ajout des pièces pour le/la candidat(e)"}
                    id="candidat"
                  />
                  <Chip
                    active={selected === "conjoint"}
                    key={"conjoint"}
                    onClick={() => handleSelectCandidat("conjoint")}
                    label={"Ajout des pièces pour le/la conjoint(e)"}
                    id={"conjoint"}
                  />
                </Grid>
                <div className={"iframeWrapper"}>
                  {selected === "candidat" && (
                    <>{token && <IframePieces token={token} />}</>
                  )}
                  {selected === "conjoint" && (
                    <>
                      <IframePieces token={tokenConjoint} isConjoint />
                    </>
                  )}
                </div>
              </>
            ) : (
              <div className={"iframeWrapper"}>
                {token && <IframePieces token={token} />}
              </div>
            )}
            <FormButtons
              onPrecedent={handlePrecedent}
              onClick={handleSuivant}
              fetching={false}
              canCancel={selectedDossier}
            />
          </>
        </Box>
      </Layout>
    </React.Fragment>
  );
}

export default PiecesJustificativesPage;
